<template>
    <div class="app-box">
       
        <div class="ar-scan-box" v-if="type !== 'found'">
            <ScanningView />
        </div>


        <VoiceView  v-if="(url === 'hsjn' || url === 'blfjjp' || url === 'fkp' || url === 'blfrjn' || url === 'blfkl' || url === 'blfhsj') && type == 'found'" />


        <div class="product-ui-box" v-if="type === 'found'">
            <ProductViewerYsc v-if="url === 'ysc'" />
            <ProductViewerFbd
                v-else-if="url === 'hsjn' || url === 'blfjjp' || url === 'fkp' || url === 'blfrjn' || url === 'blfkl' || url === 'blfhsj' " />
            <ProductViewer v-else />
        </div>

        <!-- <div class="product-ui-box">
           <ProductViewerFbd/>
        </div> -->

        <div class="effect-box" v-if="isPlay && url !== 'ysc'">
            <EffectViewer  :style="{ top: url === 'hsjn' || url === 'blfjjp' || url === 'fkp' || url === 'blfrjn' || url === 'blfkl' || url === 'blfhsj' ? '-1vh' : '' }"/>
        </div>
        <div :class="!isHideModel ? 'model-box' : 'model-box move-up'">
            <ModelViewer :top="url === 'hsjn' || url === 'blfjjp' || url === 'fkp' || url === 'blfrjn' || url === 'blfkl' || url === 'blfhsj' ? '0vh' : '0vh'"/>
        </div>
         <!-- <div class="model-box">
            <ModelViewer />
        </div> -->

        <div :class="!isHideModel ? 'model-control' : 'model-control move-up'" v-if="type === 'found'">
            <ModelControl v-if="url === 'ysc'"
                :top="'65vh'" />
                <ModelControl v-else
                :top="url === 'hsjn' || url === 'blfjjp' || url === 'fkp' || url === 'blfrjn' || url === 'blfkl' || url === 'blfhsj'  ? '58vh' : '50vh'" />
        </div>

        <div class="bg-mask" v-if="type === 'found' && url != 'ysc'">

        </div>

        <div class="bg-box ysc" v-if="type === 'found' && url == 'ysc'">
            <img src="img/img-centrum-ysc.png" alt="LOGO" style="width:70vw;">
        </div>

        <!-- <div class="bg-box ysc" >
             <img src="img/img-centrum-ysc.png" alt="LOGO" style="width:77vw;">
        </div> -->


        <div class="ar-mindar-box">
            <mindar-viewer @onTargetFound="onTargetFound" />
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import blfhsj from '@/views/otc/blfhsj.vue'
import ModelViewer from '@/components/ModelViewer.vue'
import EffectViewer from '@/components/EffectViewer.vue'
import ProductViewer from '@/components/ProductViewer.vue'
import ProductViewerYsc from '@/components/ProductViewer_ysc.vue'
import ProductViewerFbd from '@/components/ProductViewer_fbd.vue'
import MindarViewer from '@/components/MindarViewer.vue'
import ModelControl from '@/components/ModelControl.vue'
import ScanningView from '@/components/ScanningView.vue'
import VoiceView from '@/components/VoiceView.vue'
import { getToken, getAliyunSigned } from '@/api/service';
import { eventBus } from "@/utils/eventBus"

const isHideModel = ref(false);
const type = ref(String);
const url = ref(String);
const isPlay = ref(true)
function onTargetFound(data) {
    console.log(data)
    url.value = data.path;
    type.value = data.message
    localStorage.setItem('model_url', data.path),
        localStorage.setItem('model_name', data.name)
    eventBus.emit("model_found", "found")
    // if (url === 'ysc') {
    //     eventBus.emit("model_found", "found")
    // }
}

/**
 * 初始化数据
 */
function initData() {
    //获取token
    getToken({ client_id: 3, client_secret: 'sk_test_abcdef123456789' }).then(res => {
        if (res) {
            localStorage.setItem('haleon_token', res.access_token)
        }
    })

    //重新加载
    eventBus.on('message', handleMessage);
    //模型动画播放完成
    eventBus.on('model_end', handleEnd);
    eventBus.on("hide_model", handleHideModel);
    eventBus.on("show_model", handleShowModel);
}

function handleHideModel() {
    isHideModel.value = true
}

function handleShowModel() {
    isHideModel.value = false
}

function handleMessage() {
    console.log('reset')
    type.value = 'reset'
    isHideModel.value = false;
    isPlay.value = true;
    //window.location.reload()
}

function handleEnd() {
    //isPlay.value = false
}

initData();

</script>

<style lang="scss" scoped>
.app-box {
    background-color: #333;
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;

    .ar-scan-box {
        width: 100vw;
        height: 100vh;
        position: absolute;
        z-index: 9;
        left: 0;
        right: 0;
        overflow: hidden;
    }

    .ar-mindar-box {
        width: 100vw;
        height: 100vh;
        position: absolute;
        z-index: 8;
        left: 0;
        right: 0;
        overflow: hidden;
    }

    .model-box {
        width: 100vw;
        height: 100vh;
        position: absolute;
        z-index: 10;
        left: 0;
        right: 0;
        overflow: hidden;
    }

    .bg-box {
        width: 100vw;
        height: 100vh;
        position: absolute;
        z-index: 9;
        left: 0;
        right: 0;
        overflow: hidden;
        display: flex;
        align-items: flex-start;
        justify-content: center;
    }

    .ysc {
        user-select: none;
        pointer-events: none;
        background-image: url('/img/bg-sc.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        object-fit: cover;
    }

    .effect-box {
        width: 100vw;
        height: 90vh;
        position: absolute;
        z-index: 10;
        left: 0vw;
        right: 0vw;
        overflow: hidden;

    }

    .product-ui-box {
        width: 100vw;
        height: 100vh;
        position: absolute;
        overflow: hidden;
        z-index: 11;
        left: 0;
        right: 0;
        user-select: none;
        pointer-events: none;

    }

    .model-control {
        width: 100vw;
        height: 100vh;
        user-select: none;
        pointer-events: none;
        z-index: 10;
        left: 0;
        right: 0;
        position: absolute;
        overflow: hidden;
    }
}

.bg-mask {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9;
}

.move-up {
    animation: move-up 0.6s;
    animation-fill-mode: forwards;
}

@keyframes move-up {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}
</style>